import type { CroTest } from '../types/CroTestType'

/** For each active CRO test, add the test name as a class to the <body> tag. */
export function handleBodyClassTweaks(tests: CroTest[]) {
  tests
    .filter(test => test.active)
    .forEach(test => document.body.classList.add(test.name))
}
